var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 6.89591C0.833313 5.77984 1.73807 4.87508 2.85415 4.87508H4.83331C5.29355 4.87508 5.66665 5.24818 5.66665 5.70841V8.08341C5.66665 8.54365 5.29355 8.91675 4.83331 8.91675H2.85415C1.73807 8.91675 0.833313 8.01199 0.833313 6.89591ZM2.85415 6.54175C2.65855 6.54175 2.49998 6.70031 2.49998 6.89591C2.49998 7.09152 2.65855 7.25008 2.85415 7.25008H3.99998V6.54175H2.85415Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99982 3.33333C3.99982 2.8731 4.37291 2.5 4.83315 2.5H17.4998C17.9601 2.5 18.3332 2.8731 18.3332 3.33333V11.25C18.3332 11.7102 17.9601 12.0833 17.4998 12.0833H15.1248C14.6646 12.0833 14.2915 11.7102 14.2915 11.25V8.91667L4.83331 8.91675C4.37308 8.91675 3.99982 8.54357 3.99982 8.08333V3.33333ZM5.66648 4.16667V7.25H14.2915C15.212 7.25 15.9581 7.99619 15.9581 8.91667V10.4167H16.6665V4.16667H5.66648Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99982 5.70841C3.99982 5.24818 4.37308 4.87508 4.83331 4.87508H17.4998C17.9601 4.87508 18.3331 5.24818 18.3331 5.70841C18.3331 6.16865 17.9601 6.54175 17.4998 6.54175H4.83315C4.37291 6.54175 3.99982 6.16865 3.99982 5.70841Z",
    fill: "#4F5E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66665 6.06252C2.12688 6.06252 2.49998 6.43568 2.49998 6.89591V15.0834C2.49998 16.0038 3.24617 16.75 4.16665 16.75H14.2916L14.2915 8.91667L8.39581 8.91669C7.93558 8.91669 7.56248 8.54359 7.56248 8.08335C7.56248 7.62312 7.93558 7.25002 8.39581 7.25002L14.2915 7.25C15.212 7.25 15.9581 7.99619 15.9581 8.91667L15.9583 16.75C15.9583 17.6705 15.2121 18.4167 14.2916 18.4167H4.16665C2.3257 18.4167 0.833313 16.9243 0.833313 15.0834V6.89591C0.833313 6.43568 1.20641 6.06252 1.66665 6.06252Z",
    fill: "#4F5E71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 6.89591C0.833313 5.77984 1.73807 4.87508 2.85415 4.87508H8.39581C8.85605 4.87508 9.22915 5.24818 9.22915 5.70841C9.22915 6.16865 8.85605 6.54175 8.39581 6.54175H2.85415C2.65855 6.54175 2.49998 6.70031 2.49998 6.89591C2.49998 7.09152 2.65855 7.25008 2.85415 7.25008L8.39581 7.25002C8.85605 7.25002 9.22915 7.62318 9.22915 8.08341C9.22915 8.54365 8.85605 8.91669 8.39581 8.91669L2.85415 8.91675C1.73807 8.91675 0.833313 8.01199 0.833313 6.89591Z",
    fill: "#4F5E71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 12.5C10.8333 12.0398 11.2064 11.6667 11.6666 11.6667H11.675C12.1352 11.6667 12.5083 12.0398 12.5083 12.5C12.5083 12.9602 12.1352 13.3333 11.675 13.3333H11.6666C11.2064 13.3333 10.8333 12.9602 10.8333 12.5Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.4164b040285e79bf6b74cd1d18a57fd6.svg";
export { ForwardRef as ReactComponent };